import * as React from 'react';

import { translate } from '~l10n/client';

import { Container } from '~shared/components/Container/Container';

import { DeliveryMethodSelection } from './DeliveryMethodSelection';
import { ToggleSettings } from './ToggleSettings';

export function SelectSettings() {
  return (
    <Container width={1} className={'pt-4 overflow-hidden'}>
      <div style={{ height: '100%', overflow: 'auto' }}>
        <Container className={'flex-col md:flex-row'}>
          <Container width={1} className={'p-3'}>
            <span
              className={'text-base font-display text-blue-900 font-700 mb-4'}
            >
              {translate('Delivery Method')}
            </span>
            <DeliveryMethodSelection />
          </Container>
          <Container width={1} className={'p-3'}>
            <span
              className={'text-base font-display text-blue-900 font-700 mb-4'}
            >
              {translate('Settings')}
            </span>
            <ToggleSettings />
          </Container>
        </Container>
      </div>
    </Container>
  );
}
